import React, { useState, useEffect } from 'react';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useFormFieldArray } from '@uhg-abyss/web/hooks/useFormFieldArray';
import { LicenseServicing } from './LicenseServicing';

export const License = () => {
  const form = useForm();
  const practiceInfo = form.getValues('practiceInformation');

  const [licenseCount, setLicenseCount] = useState([]);
  const { append, remove } = useFormFieldArray({
    control: form.control,
    name: 'practiceInformation.medLicense',
  });
  const handleAddLicense = () => {
    append({ licenseType: '', licenseNumber: '', state: '' });
    setLicenseCount(licenseCount + 1);
  };
  const handleRemoveLicense = (index) => {
    setLicenseCount(licenseCount - 1);
    remove(index);
  };

  const loadLicense = (index) => {
    return [...Array(index).keys()].map((address) => {
      return (
        <Grid.Col span="100%" id="attest-inputs" key={address}>
          <LicenseServicing
            index={address}
            licenseCount={licenseCount}
            handleRemoveLicense={() => {
              return handleRemoveLicense(address);
            }}
            handleAddLicense={() => {
              return handleAddLicense(address);
            }}
          />
        </Grid.Col>
      );
    });
  };

  useEffect(() => {
    let count = 0;
    if (
      practiceInfo &&
      practiceInfo.medLicense &&
      practiceInfo.medLicense.length
    ) {
      practiceInfo.medLicense.forEach((value) => {
        if (value && value != null) {
          count += 1;
          setLicenseCount(count);
        }
      });
    } else {
      setLicenseCount(2);
    }
  });
  return (
    <React.Fragment>
      <Grid>
        <Grid.Col span="100%">
          {licenseCount === 1 && loadLicense(licenseCount)}
          {licenseCount === 2 && loadLicense(licenseCount)}
          {licenseCount === 3 && loadLicense(licenseCount)}
          {licenseCount === 4 && loadLicense(licenseCount)}
          {licenseCount === 5 && loadLicense(licenseCount)}
        </Grid.Col>
      </Grid>
    </React.Fragment>
  );
};

License.propTypes = {};

License.defaultProps = {};
